import moment from "moment"

var mixin = {
  methods: {
    date2unixtimestamp(dateStr) {
      return moment(dateStr, "YYYY-MM-DD").format("X")
    },
    today() {
      return moment().format("YYYY-MM-DD")
    },
    getStringByFormat(date) {
      return moment(date).format("YYYY-MM-DD")
    }
  }
}

export { mixin }
